import styled from 'styled-components';

import Table, { TABLE_SIZES } from '../../sheets/components/Table';

export const StyledPackagesCustomDataView = styled(Table).attrs({
  tableSize: TABLE_SIZES.LARGE,
  enableColumnResizing: true,
})`
  th {
    text-align: left;
  }
`;
